export default __webpack_public_path__ + "static/media/agent-role-other-green.7b99b69f.svg";